<template>
  <div id="UserPasswordManage" class="content-view" style="position: relative">
    <div class="searchStyle">
      <van-search
        v-model="search"
        show-action
        placeholder="请输入用户名"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <div>
      <div
        v-for="(item, index) in userList"
        class="trainHButton"
        :id="item.UserName"
        :key="index"
      >
        <div class="roleName">
          {{ item.UserName }}
          <van-button
            style="float: right; margin-right: 0.5rem"
            @click="resetPassword(item.UserID)"
            size="small"
            type="warning"
            >{{ "重置密码" }}</van-button
          >
        </div>
        <span style="font-size: 15px; color: grey">{{ item.AddrName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  name: "UserPasswordManage",
  data () {
    return {
      search: "",
      searchOldVal: "",
      userList: [],
      params: {
        WorkID: this.getWork().WorkID,
        OrganID: this.getWork()
          ? this.getAddr().OrganID
          : this.getAuth().OrganID
      }
    };
  },
  watch: {

  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  methods: {
    onSearch () {
      if (this.search) {
        let state = false
        if (this.searchOldVal) {
          let div = document.getElementById(this.searchOldVal)
          div.style.backgroundColor = ""
        }
        for (let i = 0; i < this.userList.length; i++) {
          if (this.userList[i].UserName == this.search || this.userList[i].AddrName == this.search) {
            state = true
            this.searchOldVal = this.search
            let div = document.getElementById(this.search)
            div.style.backgroundColor = "#eeeee7"
            const offsetTop = div.offsetTop - 60;
            window.scrollTo(0, offsetTop);
            break;
          }
        }
        if (!state) {
          this.$toast("此用户不存在");
        }
      }
      else {
        // this.$toast("请输入用户名");
        return
      }
    },
    // 获取账号表
    getExamUserPasswordList () {
      this.apiExamUserPasswordGet(this.params, this, res => {
        this.userList = res.data
      });
    },
    // 重置密码
    resetPassword (id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否重置密码？"
        })
        .then(() => {
          var json = {
            WorkID: this.getWork().WorkID,
            OpenID: id
          };
          this.apiExamUserPasswordPut(json, this, res => {
            if (res.code == 20000) {
              Dialog.confirm({
                message: "设置成功！\r\n密码为：kwgzry",
                confirmButtonText: "复制密码",
                showCancelButton: false,
                cancelButtonText: "取消"
              })
                .then(() => {
                  // navigator.clipboard.writeText("kwgzry");
                  const input = document.createElement('input');
                  input.value = "kwgzry"; // 要复制的文本
                  document.body.appendChild(input);
                  input.select(); // 选中输入框内容
                  // document.execCommand('copy'); // 执行复制操作

                  if (document.execCommand("Copy")) {
                    document.execCommand("Copy")
                  } else {
                    oInput.setSelectionRange(0, oInput.value.length), document.execCommand('Copy');
                  }

                  document.body.removeChild(input); // 移除输入框
                })
                .catch(() => {
                  // 取消操作
                  return
                });
            } else {
              this.$toast(res.message);
            }
          });
        });
    },
  },
  created () {
    this.getExamUserPasswordList()
  }
};
</script>

<style scoped>
.trainHButton {
  text-align: left;
  position: relative;
  /* width: 90%; */
  /* height: 5.5rem; */
  padding: 10px;
  border-top: 0px solid #ebeef5;
  border-left: 0px solid #ebeef5;
  border-right: 0ch solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  margin: auto;
}
.trainHButton:first-child {
  border-top: 1px solid #e7e7d5;
}
.roleName {
  font-size: 1.4rem;
  font-weight: 550;
  margin-bottom: 0.2rem;
}
.content-view {
  /* height: 95vh; */
  width: 100%;
  overflow: auto;
  padding-top: 50px;
  margin-top: -50px;
}
</style>